const checkSwatches = () => {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
    const overlayLink = wrapper.querySelector('.js-color-swatches-link');
    const originalLink = overlayLink ? overlayLink.getAttribute('href') : null;
    let lockedVariantId = null;
    let lockedVariantLink = null;

    wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
      input.addEventListener('change', () => {
        const variantId = input.dataset.variantId;
        const variantLink = input.dataset.variantLink;

        lockedVariantId = variantId || null;
        lockedVariantLink = variantLink || null;

        wrapper.querySelectorAll('.variant-hover-image.is-active').forEach(img => {
          img.classList.remove('is-active');
        });
        if (lockedVariantId) {
          const variantImg = wrapper.querySelector('.variant-hover-image[data-variant-id="' + lockedVariantId + '"]');
          if (variantImg) variantImg.classList.add('is-active');
        }
        if (lockedVariantLink && overlayLink) overlayLink.setAttribute('href', lockedVariantLink);
      });
    });

    const swatchesContainer = wrapper.querySelector('.js-color-swatches');
    if (!swatchesContainer) return;

    const restoreLockedOrDefault = () => {
      wrapper.querySelectorAll('.variant-hover-image.is-active').forEach(img => {
        img.classList.remove('is-active');
      });
      if (lockedVariantId) {
        const variantImg = wrapper.querySelector('.variant-hover-image[data-variant-id="' + lockedVariantId + '"]');
        if (variantImg) variantImg.classList.add('is-active');
        if (lockedVariantLink && overlayLink) overlayLink.setAttribute('href', lockedVariantLink);
      } else {
        if (overlayLink && originalLink) overlayLink.setAttribute('href', originalLink);
      }
    };

    swatchesContainer.addEventListener('mouseover', (event) => {
      const label = event.target.closest('label.color-swatch');
      if (!label) return;

      const input = document.getElementById(label.htmlFor);
      if (!input) return;

      const variantId = input.dataset.variantId;
      const variantLink = input.dataset.variantLink;

      // Deactivate previous variant image
      wrapper.querySelectorAll('.variant-hover-image.is-active').forEach(img => {
        img.classList.remove('is-active');
      });

      // Activate matching variant image
      if (variantId) {
        const variantImg = wrapper.querySelector('.variant-hover-image[data-variant-id="' + variantId + '"]');
        if (variantImg) variantImg.classList.add('is-active');
      }

      if (variantLink && overlayLink) overlayLink.setAttribute('href', variantLink);
    });

    swatchesContainer.addEventListener('mouseleave', restoreLockedOrDefault);
  });
};

function colorSwatches() {
  checkSwatches();
  document.addEventListener('shopify:section:load', checkSwatches);
}

window.reinitColorSwatchHover = checkSwatches;

(function () {
  colorSwatches();
  initProductCardVideos();
})();

function initProductCardVideos() {
  document.querySelectorAll('.card-wrapper').forEach(function (card) {
    var secondVideoWrapper = card.querySelector('.product-card__video-wrapper.media--second');
    if (!secondVideoWrapper) return;

    var video = secondVideoWrapper.querySelector('video');
    if (!video) return;

    video.pause();

    card.addEventListener('mouseenter', function () {
      video.currentTime = 0;
      video.play();
    });

    card.addEventListener('mouseleave', function () {
      video.pause();
    });
  });
}
